function GlobalStudies() {
  return <h1>Global Studies</h1>;
}

export default GlobalStudies;